import ContainerWrapper from "@Components/generic/container-wrapper";
import TitleWrapper from "@Containers/shared/title-wrapper";
import { Events } from "@Context/common/general/context";
import { VRHeaderButtonType } from "@Enums/index";
import useI18n from "@i18n";
import { Alert, Button, Container, Skeleton, Stack } from "@mui/material";
import { ReactNode, useEffect } from "react";

type SettingsPageProps = {
  id: string;
  title: string;
  ready: boolean;
  error: Error | null;
  refetch: () => unknown;
  children: ReactNode;
};

export default function SettingsPage({ id, title, ready, error, refetch, children }: SettingsPageProps) {
  const { i18n } = useI18n();

  useEffect(() => {
    Events.app.showHeaderButton.emit({ type: VRHeaderButtonType.BACK, title });
  }, [title]);

  if (!ready) {
    return (
      <Container>
        {error ? (
          <Alert severity="error" action={<Button onClick={() => void refetch()}>{i18n("retry")}</Button>}>
            {error.message}
          </Alert>
        ) : (
          <Skeleton variant="rounded" height={180} />
        )}
      </Container>
    );
  }

  return (
    <ContainerWrapper id={id} sx={{ overflow: "visible" }}>
      <Container maxWidth="sm" sx={{ pt: 0, px: 0, pb: 6 }}>
        <TitleWrapper title={title}>
          <Stack spacing={5}>{children}</Stack>
        </TitleWrapper>
      </Container>
    </ContainerWrapper>
  );
}
